import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/industries.css';
import humanResourcesImg from '../../assets/human-resources.jpg';

const HumanResources = () => (
  <div
    className="industry-page"
    style={{ backgroundImage: `url(${humanResourcesImg})` }}
  >
    <motion.div
      className="industry-content"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1>Human Resources</h1>
      <p>
        Powering modern HR tech — from hiring to retirement — using automation, analytics, and seamless employee experiences.
      </p>
      <ul className="bullet-points">
        <li>🧑‍💼 Talent acquisition platforms.</li>
        <li>🗂️ Payroll & HCM systems.</li>
        <li>📊 Employee engagement analytics.</li>
        <li>🕹️ Performance & feedback tools.</li>
      </ul>
    </motion.div>
  </div>
);

export default HumanResources;
